import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Radio, RadioChangeEvent, Row, Select, Space, Upload } from "antd";

import { useAsyncAxios, utilAxiosFormWithAuth, utilAxiosWithAuth } from "../utils/customAxios";
import { AlertType, useAlert } from "../provider/AlertProvider";
import type { UploadFile } from "antd/es/upload/interface";
import { UploadOutlined } from "@ant-design/icons";
import type { UploadProps } from "antd";

import * as Types from "../commons/typeDTO";
import * as Request from "../commons/request";

const formItemLayout = {
    labelCol: {
        sm: {
            span: 5,
        },
    },
    wrapperCol: {
        sm: {
            span: 19,
        },
    },
};

function RegisterManual({ editMode, manual, onRegisterManual }: { editMode: string; manual?: Types.ManualDto; onRegisterManual?: () => void }) {
    const [form] = Form.useForm();
    const alert = useAlert();

    const [manualName, setManualName] = useState("");
    const [manualVersion, setManualVersion] = useState("");
    const [attachFiles, setAttachFiles] = useState<Array<any>>([]);

    const requestAxiosAddManual = async (data: any) => {
        // console.log("data : " + data);

        const response = await utilAxiosFormWithAuth().post(Request.MANUAL_URL, data);

        return response.data;
    };

    const {
        loading: loadingAddManual,
        error: errorAddManual,
        data: resultAddManual,
        execute: requestAddManual,
    } = useAsyncAxios(requestAxiosAddManual);

    useEffect(() => {
        if (manual === undefined) return;

        form.setFieldsValue(manual);
    }, [manual]);

    useEffect(() => {
        if (resultAddManual === null) return;

        if (onRegisterManual) onRegisterManual();

        alert.setAlert(AlertType.SUCCESS, "매뉴얼 추가 성공", "매뉴얼 추가를 완료하였습니다.");
    }, [resultAddManual]);

    useEffect(() => {
        if (errorAddManual === null) return;

        console.log("errorManual", errorAddManual);
        alert.setAlert(errorAddManual.response.data.code, "매뉴얼 추가 실패", errorAddManual.response.data.message);
    }, [errorAddManual]);

    const requestAxiosUpdateManual = async (data: any, manualId: number) => {
        const response = await utilAxiosFormWithAuth().put(Request.MANUAL_URL + "/" + manualId, data);

        return response.data;
    };

    const {
        loading: loadingUpdateManual,
        error: errorUpdateManual,
        data: resultUpdateManual,
        execute: requestUpdateManual,
    } = useAsyncAxios(requestAxiosUpdateManual);

    useEffect(() => {
        if (resultUpdateManual === null) return;

        if (onRegisterManual) onRegisterManual();

        alert.setAlert(AlertType.SUCCESS, "매뉴얼 수정 성공", "매뉴얼 수정을 완료하였습니다.");
    }, [resultUpdateManual]);

    useEffect(() => {
        if (errorUpdateManual === null) return;

        console.log("errorUpdateManual", errorUpdateManual);
        alert.setAlert(errorUpdateManual.response.data.code, "매뉴얼 수정 실패", errorUpdateManual.response.data.message);
    }, [errorUpdateManual]);

    const onFinish = async (values: any) => {
        const formData = new FormData();
        formData.append("manualDto", new Blob([JSON.stringify(values)], { type: "application/json" }));

        for (const file in attachFiles) {
            const response = await fetch(URL.createObjectURL(attachFiles[file]));
            const blob = await response.blob();
            const data = new File([blob], attachFiles[file].name, { type: blob.type });

            formData.append("manualFile", data);
        }
        if (editMode === "add") requestAddManual(formData);
        else if (editMode === "update") requestUpdateManual(formData, values.manualId);
    };

    const propsAttachFiles = {
        onRemove: (file: any) => {
            const index = attachFiles.indexOf(file);
            const newAttachFiles = attachFiles.slice();
            newAttachFiles.splice(index, 1);
            setAttachFiles(newAttachFiles);
        },
        beforeUpload: (file: any) => {
            setAttachFiles([...attachFiles, file]);
            return false;
        },
        fileList: attachFiles,
    };

    return (
        <div>
            <Form form={form} onFinish={onFinish}>
                <Space size={20} direction="vertical" style={{ width: "100%" }}>
                    <Row>
                        <Col span={12}>
                            <Form.Item className="searchForm" {...formItemLayout} name="manualId" label="매뉴얼 ID">
                                <Input readOnly />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="manualName"
                                label="매뉴얼 이름"
                                rules={[
                                    {
                                        required: true,
                                        message: "매뉴얼 이름을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="매뉴얼 이름을 입력해 주세요." onChange={(e) => setManualName(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="manualVersion"
                                label="매뉴얼 버젼"
                                rules={[
                                    {
                                        required: true,
                                        message: "매뉴얼 버젼을 입력해 주세요.",
                                    },
                                ]}
                            >
                                <Input placeholder="매뉴얼 버젼을 입력해 주세요." onChange={(e) => setManualVersion(e.target.value)} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                className="searchForm"
                                {...formItemLayout}
                                name="manualFile"
                                label="매뉴얼 파일"
                                rules={[
                                    {
                                        required: editMode === "add" ? true : false,
                                        message: "매뉴얼 파일을 추가해 주세요.",
                                    },
                                ]}
                            >
                                <Upload {...propsAttachFiles} multiple={true}>
                                    <Button icon={<UploadOutlined />}>Upload PDF only</Button>
                                </Upload>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row justify="end">
                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {editMode === "add" ? "등록" : "수정"}
                            </Button>
                        </Form.Item>
                    </Row>
                </Space>
            </Form>
        </div>
    );
}

export default RegisterManual;
